import styled from 'styled-components';
import type { InsightCalloutBlock } from '../../types';

const Wrap = styled.aside`
  max-width: 46rem;
  margin: 0 auto;
  padding: 1.45rem 1.5rem;
  border-radius: 24px;
  border: 1px dashed rgba(20, 34, 53, 0.16);
  background: transparent;
  color: #132235;
`;

const Title = styled.h3<{ $accent: string }>`
  margin: 0 0 0.55rem;
  font-size: 0.82rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-weight: 900;
  color: ${({ $accent }) => $accent};
`;

const Text = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.74;
  color: rgba(20, 34, 53, 0.82);
`;

type CalloutBlockProps = {
  block: InsightCalloutBlock;
  accent: string;
};

export default function CalloutBlock({ block, accent }: CalloutBlockProps) {
  return (
    <Wrap>
      {block.title ? <Title $accent={accent}>{block.title}</Title> : null}
      <Text>{block.text}</Text>
    </Wrap>
  );
}
